import { useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';

import { useAppDownloadPromptExperiment } from './useAppDownloadPrompt.experiment';

/**
 * LAAC-1711: Eligibility for scheduling the app download prompt (treatment + authenticated web session).
 * Separates experiment assignment from frequency-cap / dismissal rules (LAAC-1715) and from trigger UI (LAAC-1712/1713).
 */
export const useAppDownloadPromptEligibility = (): boolean => {
    const isTreatment = useAppDownloadPromptExperiment();
    const loggedIn = useAppSelector(isUserLoggedIn);

    return isTreatment && loggedIn;
};
